import { useAppStore } from "@/composables";
import { useUser } from "@/composables/user";
import { isPublic } from "@/router/helpers";
import { checkUserOnInitialPageLoad } from "@/services/user/auth/login";
import { type NavigationGuardNext, type RouteLocationNormalized } from "vue-router";

export const handleRedirectForLoggedInUser = async (route: RouteLocationNormalized, _: RouteLocationNormalized, next: NavigationGuardNext) => {
  await checkUserOnInitialPageLoad();
  const { isUserLoggedIn } = useUser();

  if (isUserLoggedIn.value && isPublic(route)) {
    const redirect = route.meta.redirectWhenLoggedIn;
    if (redirect) {
      const countryCode = useAppStore().countryCode.value;
      if (countryCode === undefined) {
        throw new Error("Cannot redirect user when country is not determined.");
      }

      const newRoute = {
        ...redirect,
        params: {
          ...redirect.params,
          countryCode,
        },
      };
      return next(newRoute);
    }
  }

  return next();
};
